import { PropTypes } from 'react';

const Toolbar = ({ children }) => (
    <div className="cn-toolbar cn-toolbar--filters" >
        {children}
    </div>
);

Toolbar.propTypes = {
    children: PropTypes.node
};

export default Toolbar;




// WEBPACK FOOTER //
// ./app/components/toolbar.jsx